import type { Channel } from '../types';

export const GUIDE_CHANNELS = [
  {
    key: 'NAVER_BLOG',
    tab: '네이버 블로그',
    tip: '웰로·지역·답례품이 들어간 제목을 정하고, 선택 이유 → 상세 조건 → 추천 링크 순서로 작성하세요.',
  },
  {
    key: 'INSTAGRAM',
    tab: '인스타그램',
    tip: '릴스·카드뉴스 도입에 웰로를 선택할 이유를 담고, 확인된 조건과 프로필 링크를 안내하세요.',
  },
  {
    key: 'YOUTUBE',
    tab: '유튜브',
    tip: '영상에서 직접 확인한 선택 이유·답례품·조건을 설명하세요. 일반 영상은 설명란에, Shorts는 프로필이나 관련 영상에 링크를 연결하세요.',
  },
  {
    key: 'PERSONAL_BLOG',
    tab: '개인블로그',
    tip: '본인 블로그에 독자의 질문을 제목·소제목으로 쓰고, 공식 출처·확인일·추천 링크를 넣으세요.',
  },
] as const;

export type GuideChannelKey = (typeof GUIDE_CHANNELS)[number]['key'];

export const GUIDE_KEYWORDS = [
  '웰로',
  '고향사랑기부',
  '[지역명]',
  '[답례품명 또는 이벤트명]',
];

const GUIDE_HASHTAGS =
  '#웰로 #웰로고향사랑기부 #고향사랑기부제 #답례품 #지역응원 #[지역명]';

const LINK_PLACEHOLDER = '[내 추천 링크]';

const GUIDE_SAMPLES: Record<GuideChannelKey, string[]> = {
  NAVER_BLOG: [
    '제목: [지역명] 고향사랑기부, 웰로에서 [답례품명]을 살펴본 이유',
    '어디서 기부할지 고민하다 웰로에서 답례품과 참여 지역 이벤트를 함께 살펴봤습니다.',
    '제가 웰로를 소개하는 이유는 [직접 확인한 기능·혜택]입니다.',
    '답례품 구성: [공식 정보]',
    '참여 조건: [기부금액·대상 지역·기간]',
    '확인할 사항: [배송 일정·이벤트 중복 조건]',
    `최신 정보와 기부 화면: ${LINK_PLACEHOLDER}`,
    '세액공제는 개인의 세금 상황에 따라 달라질 수 있습니다.',
  ],
  INSTAGRAM: [
    '1장: 고향사랑기부, 왜 웰로에서?',
    '2장: [지역명]의 [답례품명]을 살펴보고 참여 지역 이벤트도 확인해요.',
    '3장: 제가 확인한 웰로의 선택 이유는 [확인된 기능·혜택]입니다.',
    '4장: [기부금액·기간·혜택 조건]을 먼저 확인하세요.',
    '5장: 자세한 내용은 프로필의 추천 링크에서 확인하세요.',
    `프로필 링크: ${LINK_PLACEHOLDER}`,
  ],
  YOUTUBE: [
    '제목: 고향사랑기부, 왜 웰로에서? 확인할 3가지',
    '오늘은 웰로에서 [지역명]의 [답례품명 또는 이벤트명]을 살펴볼 이유를 소개합니다.',
    '첫째, [직접 확인한 웰로의 기능·혜택].',
    '둘째, [답례품 구성과 배송 일정].',
    '셋째, [참여 대상·기간·기부금액 조건].',
    '일반 영상: 설명란의 추천 링크에서 최신 정보를 확인하세요.',
    'Shorts: 채널 프로필 또는 관련 영상에서 확인하세요.',
    `설명/프로필에 넣을 링크: ${LINK_PLACEHOLDER}`,
  ],
  PERSONAL_BLOG: [
    '제목: 고향사랑기부 어디서 할까? 웰로의 답례품과 이벤트 확인하기',
    '웰로를 살펴볼 이유는 무엇인가요?',
    '[직접 확인한 기능·혜택과 선택 이유]',
    '어떤 지역과 답례품을 볼 수 있나요?',
    '[지역명·답례품명·공식 구성 정보]',
    '기부 전에 무엇을 확인해야 하나요?',
    '[금액·참여 기간·조건·배송 일정]',
    `최신 안내: ${LINK_PLACEHOLDER}`,
    '정보 확인일: [날짜] / 출처: [공식 안내]',
  ],
};

//* 기타 채널은 기획서 11-4대로 네이버 블로그 가이드를 보여 준다
export const guideChannelOf = (channel: Channel): GuideChannelKey =>
  GUIDE_CHANNELS.find((item) => item.key === channel)?.key ?? 'NAVER_BLOG';

export const sampleTextOf = (
  key: GuideChannelKey,
  linkUrl = LINK_PLACEHOLDER,
) => [
  ...GUIDE_SAMPLES[key].map((line) => line.replace(LINK_PLACEHOLDER, linkUrl)),
  GUIDE_HASHTAGS,
];
